import useTelemedicineRequestCompleteViewModel from './useTelemedicineRequestCompleteViewModel';

export { useTelemedicineRequestCompleteViewModel };
